"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSDiagnosticCheckComponent = void 0;
const core_1 = require("@angular/core");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const device_service_1 = require("../../devices/services/device.service");
const usage_service_1 = require("../../usage/services/usage.service");
const account_service_1 = require("../services/account.service");
const helper_service_1 = require("../services/helper.service");
const _ = require("underscore");
const diagnosis_request_1 = require("../models/diagnosis-request");
class CSDiagnosticCheckComponent {
    constructor(accountService, usageService, deviceService, modalService, helperService) {
        this.accountService = accountService;
        this.usageService = usageService;
        this.deviceService = deviceService;
        this.modalService = modalService;
        this.helperService = helperService;
        this.loader = false;
        this.provisioningLoader = false;
        this.diagnosticsLoader = false;
        this.startDiagnostics = false;
        this.isRestartDevice = true;
        this.isBillingIssue = false;
        this.isDataSpeedReduced = false;
        this.isSoftwareIssue = false;
        this.latestSoftware = false;
        this.isProvisioningSuccessful = false;
        this.isProvisioningFailed = false;
        this.isProvisioningRestarted = false;
        this.nearDataLimit = false;
        this.restartPhone = false;
        this.downloadLatestVersion = false;
        this.isHotLinedAccount = false;
        this.isVoluntarySuspendedSub = false;
        this.hasPastDue = false;
        this.dignosisHistorySteps = [];
        this.diagnosisRequest = new diagnosis_request_1.DiagnosisRequest();
        this.classes = 'col-md-12 mx-0 px-0';
    }
    ngOnInit() {
        this.getAccountDetails(true);
    }
    getAccountDetails(isCache) {
        this.loader = true;
        this.accountService.getAccountDetails(isCache).subscribe((accountDetails) => {
            this.accountDetails = accountDetails;
            this.subscriptions = accountDetails.subscription;
            this.selectedSubscription = this.subscriptions[0];
            this.isHotLinedAccount = accountDetails.accountHotlined;
            this.interactiveTutorialLink = this.selectedSubscription.device.tutorials;
            if (accountDetails.pastDueBalance > 0.0) {
                this.hasPastDue = true;
            }
            else {
                this.hasPastDue = false;
            }
            this.loader = false;
        }, (error) => {
            this.loader = false;
            this.error = error;
        });
    }
    selectSubscription(subscriptionId) {
        this.selectedSubscription = this.accountDetails.subscription.filter((e) => e.subscriptionId === subscriptionId);
        this.interactiveTutorialLink = this.selectedSubscription[0].device.deviceTutorialLink;
        this.startOver();
    }
    calculateDataUsage(usageInfo) {
        if (usageInfo) {
            this.totalUsedData = ((usageInfo.totalUsed / 1024) / 1024) / 1024;
            this.throttling = parseFloat(usageInfo.throttling);
            if ((usageInfo.totalAvailable === 'UNLIMITED') && (this.totalUsedData > this.throttling)) {
                this.percentUsed = 100;
            }
            else {
                this.totalUsedData = ((usageInfo.totalUsed / 1024) / 1024) / 1024;
                const availableData = parseFloat(usageInfo.totalAvailable);
                this.totalData = (((availableData / 1024) / 1024) / 1024).toFixed(2);
                const fTotalGbUsed = parseFloat(this.totalUsedData);
                const fTotalAvailable = parseFloat(this.totalData);
                if (fTotalAvailable > 0.0) {
                    this.percentUsed = (fTotalGbUsed / fTotalAvailable) * 100;
                }
                else {
                    this.percentUsed = 0;
                }
            }
        }
        if (this.percentUsed > 95) {
            this.nearDataLimit = true;
            this.isDataSpeedReduced = true;
            this.createDiagnosisList('DATA_THRESHOLD_CHECK', 'YES');
            this.diagnosticsHistory();
        }
        else {
            this.nearDataLimit = false;
            this.isSoftwareIssue = true;
        }
    }
    startDiagnostic() {
        var _a;
        if (this.subscriptions.length > 1) {
            this.selectedSubId = this.selectedSubscription[0].subscriptionId;
        }
        else {
            this.selectedSubId = this.subscriptions[0].subscriptionId;
        }
        if (this.isHotLinedAccount) {
            this.isBillingIssue = true;
            this.createDiagnosisList('IS_HOTLINED', 'YES');
            this.diagnosticsHistory();
        }
        else if (((_a = this.selectedSubscription[0]) === null || _a === void 0 ? void 0 : _a.subscriptionStatus) === 'VOLUNTARY_SUSPEND') {
            this.isVoluntarySuspendedSub = true;
            this.createDiagnosisList('IS_VOLUNTARILY_SUSPENDED', 'YES');
            this.diagnosticsHistory();
        }
        else {
            this.getUsageDetails();
        }
    }
    restartDevice(restart) {
        this.isRestartDevice = restart;
        if (this.isRestartDevice) {
            this.createDiagnosisList('DEVICE_RESTART', 'YES');
            // verify provisioning status
            this.verifyProvisioningStatus();
        }
        else {
            this.createDiagnosisList('DEVICE_RESTART', 'NO');
            // download latest software on click of no
            this.latestSoftware = true;
        }
    }
    isLatestSoftWare(latestSoftware) {
        this.latestSoftware = latestSoftware;
        if (this.latestSoftware) {
            this.downloadLatestVersion = true;
            this.createDiagnosisList('SOFTWARE_VERSION_CHECK', 'YES');
            this.diagnosticsHistory();
        }
        else {
            this.isSoftwareIssue = false;
            this.restartPhone = true;
            this.createDiagnosisList('SOFTWARE_VERSION_CHECK', 'NO');
        }
    }
    startOver() {
        this.startDiagnostics = false;
        this.isBillingIssue = false;
        this.isDataSpeedReduced = false;
        this.isSoftwareIssue = false;
        this.latestSoftware = false;
        this.isProvisioningSuccessful = false;
        this.isVoluntarySuspendedSub = false;
        this.isProvisioningFailed = false;
        this.isProvisioningRestarted = false;
        this.restartPhone = false;
        this.downloadLatestVersion = false;
        this.error = '';
        this.dignosisHistorySteps = [];
    }
    startAChat() {
        const wysdomBot = window['wysdomBot'];
        wysdomBot.openChat();
    }
    fixAll() {
        if (this.isProvisioningFailed) {
            this.fixAllDiagnostics(this.selectedSubscription[0].subscriptionId);
        }
    }
    verifyProvisioningStatus() {
        this.provisioningLoader = true;
        this.deviceService.verifyDiagnostics(this.selectedSubscription[0].mobileNumber)
            .subscribe((details) => {
            var _a;
            this.provisioningLoader = false;
            this.restartPhone = false;
            if (details) {
                if (!details.success) {
                    this.isProvisioningFailed = true;
                }
                else {
                    this.isProvisioningSuccessful = true;
                }
                if (((_a = details.stepDetails) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    for (let i = 0; i < details.stepDetails.length; i++) {
                        this.createDiagnosisList(details.stepDetails[i].stepName, 'YES', details.stepDetails[i].status);
                    }
                }
                this.diagnosticsHistory();
            }
        }, (error) => {
            this.provisioningLoader = false;
            this.error = error;
        });
    }
    restoreLine(subscriptionId) {
        this.loader = true;
        this.deviceService.restoreLine(subscriptionId)
            .subscribe((restoreInfo) => {
            this.loader = false;
            this.getAccountDetails(false);
            this.startOver();
        }, (err) => {
            this.loader = false;
            this.error = err;
        });
    }
    open(content) {
        this.modalRef = this.modalService.open(content, { size: 'sm', windowClass: 'dark-modal', centered: true });
    }
    fixAllDiagnostics(subId) {
        this.loader = true;
        this.deviceService.fixAllDiagnostics(subId)
            .subscribe((details) => {
            this.loader = false;
            this.iccid = details.iccid;
            this.currentState = details.currentState;
            if (!details.isFixAllEnabled) {
                this.open(this.diagnosticsCheck24hrsSpanPopup);
            }
            else if (details.isFixAllEnabled && details.action === 'RECONCILE') {
                this.isProvisioningFailed = false;
                this.isProvisioningSuccessful = true;
            }
            else {
                this.isProvisioningRestarted = true;
            }
            this.createDiagnosisList('FIX_PROVISIONING_ISSUE', 'YES');
            this.diagnosticsHistory();
        }, (error) => {
            this.loader = false;
            this.error = error;
        });
    }
    /**
     * Redirect to Change Plan
     */
    shopPlans() {
        this.helperService.onNavigate('/my_account/personal/#/wireless/plans');
    }
    /**
     * Redirect to Devices to purchase data passes
     */
    shopDataPasses() {
        this.helperService.onNavigate('/my_account/personal/#/wireless/device');
    }
    continueDiagnosticCheck() {
        this.isSoftwareIssue = false;
        this.restartPhone = true;
    }
    getUsageDetails() {
        this.loader = true;
        this.usageService.getDataUsage(this.selectedSubId).subscribe((res) => {
            this.loader = false;
            this.dataUsage = res.usageByDataList;
            const that = this;
            _.each(that.dataUsage, function (key, value) {
                if (that.dataUsage[value].sharedPlan !== true) {
                    that.dataUsage[value] = that.helperService.flattenObject(that.dataUsage[value]);
                }
                else {
                    that.dataUsage[value] = that.helperService.flattenObjectwithExceptions(that.dataUsage[value], ['usageSharingSubs']);
                    that.dataUsage[value].subscriptionId = that.dataUsage[value].usageSharingSubs[0].subscriptionId;
                }
            });
            this.selectedPlan = _.findWhere(this.dataUsage, { 'subscriptionId': this.selectedSubId });
            this.calculateDataUsage(this.selectedPlan);
        }, (error) => {
            this.loader = false;
            this.error = error;
        });
    }
    /**
     * Diagnostic history
     */
    diagnosticsHistory() {
        this.loader = true;
        this.diagnosisRequest.subscriptionId = this.selectedSubId;
        this.diagnosisRequest.diagnosisCheckAndResponses = this.dignosisHistorySteps;
        this.deviceService.diagnosticsHistory(this.diagnosisRequest)
            .subscribe((diagnosticHistoryHdrId) => {
            this.loader = false;
        }, (error) => {
            this.loader = false;
            this.error = error;
        });
    }
    createDiagnosisList(diagnostisCheck, responseLog, status) {
        const diagnosticSteps = {
            'diagnosisCheck': diagnostisCheck,
            'response': responseLog,
            'stepStatus': status
        };
        this.dignosisHistorySteps.push(diagnosticSteps);
    }
}
exports.CSDiagnosticCheckComponent = CSDiagnosticCheckComponent;
//# sourceMappingURL=diagnostic-check.component.js.map